export default __webpack_public_path__ + "static/media/extra_mile_logo.02278ba1.png";